import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";

const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const Bar = ({ k, label, v, target }) => (
  <div data-testid={`commission-${k}`}>
    <div className="mb-1 flex justify-between text-xs text-slate-600">
      <span>{label}</span>
      <span className="font-semibold text-slate-900">{money(v)} / {money(target)}</span>
    </div>
    <Progress value={Math.min(100, (v / target) * 100)} className="h-2" />
  </div>
);

export const CommissionBadge = ({ s, testId }) => (
  <Badge className={`border-0 ${s.commission === 100 ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`} data-testid={testId}>
    {s.commission}% commission
  </Badge>
);

export const CommissionProgress = ({ s, compact = false }) => (
  <div className={compact ? "space-y-2" : "space-y-3"} data-testid="commission-progress">
    <Bar k="week" label="This week (since Monday)" v={s.this_week} target={s.target} />
    <Bar k="avg" label={`Weekly average (${s.weeks} week${s.weeks === 1 ? "" : "s"})`} v={s.weekly_avg} target={s.target} />
    {!compact && (
      <p className="text-sm text-slate-600" data-testid="commission-status">
        {s.commission === 100
          ? "You're eligible for 100% commission: both this week's spending and your weekly average are at least $50."
          : "You're eligible for 90% commission. Reach $50 this week and a $50 weekly average to earn 100%."}
      </p>
    )}
  </div>
);
